import { Input } from './Input';
import { Select } from './Select';

export const Elements = {
  Input,
  Select,
};
